import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/index/layout.vue'
import BigScreen from '@/BigScreen.vue'////
Vue.use(VueRouter)

// 初始路由r
export const routes = [
  {
    path: '/',
    redirect: 'login',
    meta: {
      name: '初次访问'
    },
    hidden: true
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      name: '登录'
    },
    hidden: true,
    component: () => import('../views/login/login.vue')
  },
  {
    path: '/index',
    name: 'index',
    redirect: 'home',
    meta: {
      name: '主页',
      icon: 'home'
    },
    component: Layout,
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          name: '控制台',
          icon: 'console'
        },
        component: () => import('../views/index/index.vue')
      }
    ]
  },
  {
    path: '/404',
    name: 'page404',
    meta: {
      name: '页面不存在'
    },
    hidden: true,
    component: () => import('../views/error/404.vue')
  }
  /////
  // {
  //   path:'/newBigScreen',
  //   name:'NewBigScreen',
  //   meta:{
  //     name:'新首页',
  //   },
  //   component: BigScreen,
  //   children:[
  //     {
  //       path:'/homePage',
  //       name:'HomePage',
  //       meta:{
  //         name:'首页',
  //       },
  //       component: () => import('@/views/bigescreenNew/home/index.vue')
  //     },
  //     {
  //       path:'/monitorPage',
  //       name:'MonitorPage',
  //       meta:{
  //         name:'监控',
  //       },
  //       component: () => import('@/views/bigescreenNew/monitor/index.vue')
  //     }
  //   ]
  // }
]

const route = new VueRouter({
  routes
})
export default route
